export interface MatchParams {
    action: string;
    id: string;
}

export const CHANNELS_CONTEXT_PARAM = ':channelId';

export const SETTINGS_ROUTES = {
    SETTINGS_CONFIRM_PASSWORD: '/settings/confirm-password',
    SETTINGS_CONTACT_SUPPORT: '/settings/contact-support',
    SETTINGS_LAUNCHER_MONITOR: '/settings/launcher-monitor',
    SETTINGS_UPDATE_PASSWORD: '/settings/update-password'
};

export const PANEL_ROUTES = {
    SEARCH: '/panel/search/',
    DIRECTORY: '/panel/directory',
    WORKSPACES: '/panel/workspaces',
    ACTIONS: '/panel/actions',
    SETTINGS_PANEL: '/panel/settings'
};

export const SETTINGS_PANEL_ROUTES = {
    SETTINGS_PANEL_ABOUT: `${PANEL_ROUTES.SETTINGS_PANEL}/about`,
    SETTINGS_PANEL_LAUNCHBAR: `${PANEL_ROUTES.SETTINGS_PANEL}/launchbar`,
    SETTINGS_PANEL_NOTIFICATIONS: `${PANEL_ROUTES.SETTINGS_PANEL}/notifications`,
    SETTINGS_PANEL_PROFILE: `${PANEL_ROUTES.SETTINGS_PANEL}/profile`
};

export const ROUTES = {
    ...PANEL_ROUTES,
    ...SETTINGS_PANEL_ROUTES,
    ...SETTINGS_ROUTES,
    CONTEXT_MENU: '/context-menu',
    FORGOT_PASSWORD: '/forgot-password',
    HOME: '/',
    LOGIN: '/login',
    OAUTH_LOGIN: '/api/oauth',
    OAUTH_LOGOUT: '/api/oauth_logout',
    SNAPSHOT_OVERLAY: '/snapshot-overlay',
    SNAPSHOT: '/snapshot'
};
